/* Native scrolling, no slider dependency. Handles filter section replacements. */
(() => {
  if (window.hsCategorySliderReady) return;
  window.hsCategorySliderReady = true;
  const update = nav => {
    const list = nav.querySelector('ul');
    const end = Math.max(0, list.scrollWidth - list.clientWidth);
    nav.querySelector('[data-direction="-1"]').hidden = list.scrollLeft <= 2;
    nav.querySelector('[data-direction="1"]').hidden = list.scrollLeft >= end - 2;
  };
  const init = () => document.querySelectorAll('.hs-search-categories:not([data-slider-ready])').forEach(nav => {
    nav.dataset.sliderReady = 'true';
    [-1, 1].forEach(direction => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.direction = direction;
      button.setAttribute('aria-label', direction < 0 ? (nav.dataset.previous || 'Previous collections') : (nav.dataset.next || 'Next collections'));
      button.textContent = direction < 0 ? '‹' : '›';
      button.addEventListener('click', () => {
        const list = nav.querySelector('ul');
        list.scrollBy({left: direction * Math.max(200, list.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      nav.append(button);
    });
    const list = nav.querySelector('ul');
    list.addEventListener('scroll', () => update(nav), {passive:true});
    list.scrollLeft = 0;
    requestAnimationFrame(() => requestAnimationFrame(() => update(nav)));
  });
  init();
  window.addEventListener('resize', () => document.querySelectorAll('.hs-search-categories[data-slider-ready]').forEach(update), {passive:true});
  new MutationObserver(records => { if(records.some(r => r.addedNodes.length)) init(); }).observe(document.body, {childList:true, subtree:true});
})();
